export default __webpack_public_path__ + "static/media/ic-info-new.81030569.svg";